/** Names the platform has served for CerebrumX units (`CUnits.manufacturerName`). */
export const CEREBRUMX_NAMES = ['CEREBRUMX', 'CBX'];

export const isCerebrumx = (manufacturerName) =>
	typeof manufacturerName === 'string' && CEREBRUMX_NAMES.includes(manufacturerName.trim().toUpperCase());

/** Whether a unit offers the OEM data action under the `oem-raw-data-cbx-only` setting. */
export const canViewOemData = (manufacturerName, cbxOnly) => !cbxOnly || isCerebrumx(manufacturerName);
